import { Box, HStack, Text, makeUclComponent } from '@rbilabs/universal-components';

import { ExternalLink } from 'components/external-link';
import { LayoutContainer } from 'components/layout/styled';
import PictureComponent from 'components/picture';
import { theme } from 'styles/configure-theme';

export const LayoutContainerBackground = LayoutContainer.withConfig({
  backgroundColor: theme.token('background-focus'),
  marginTop: '150px',
  paddingBottom: {
    base: '$6',
    md: '$0',
  },
});

export const Section = Box.withConfig({
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',

  _web: {
    padding: 0,
    alignItems: 'stretch',
    overflow: 'visible',

    flexDirection: {
      sm: 'column',
      md: 'row',
    },
  },
});

export const ImageDesktop = Box.withConfig({
  flex: 1,
  display: {
    base: 'none',
    md: 'flex',
  },
});

export const TextHalf = Box.withConfig({
  flex: 1,
  paddingTop: {
    base: '$0',
    md: '$12',
  },
  paddingBottom: {
    base: '$0',
    md: '$20',
  },

  alignItems: {
    base: 'center',
    md: 'flex-start',
  },
  width: 'full',
});

export const ImageMobile = Box.withConfig({
  maxWidth: '$40',
  flex: 1,
  bottom: 0,
  right: '$0',
  display: {
    base: 'flex',
    md: 'none',
  },
  marginRight: '$5',
  height: '$48',
});

export const MainImageContainer = Box.withConfig({
  height: '100%',
  bottom: '10%',
  px: '10%',
  paddingBottom: '$10',
});

export const Picture = PictureComponent.withConfig({
  width: '100%',
  height: '110%',
});

export const PictureMobile = Picture.withConfig({
  position: 'absolute',
  height: '$56',
  bottom: '$0',
});

export const Header = Text.withConfig({
  fontFamily: 'heading',
  fontSize: {
    base: '3xl',
    md: '3xl',
    lg: '5xl',
  },
  lineHeight: 'xs',
  fontWeight: 'bold',
});

export const Description = Text.withConfig({
  marginTop: '$8',
});

export const BadgesContainer = HStack.withConfig({
  marginTop: {
    base: '$4',
    md: '$8',
  },
  justifyContent: {
    base: 'space-around',
    md: 'flex-start',
  },
  width: 'full',
});

export const BadgeLink = makeUclComponent(ExternalLink).withConfig({
  marginRight: {
    base: '$0',
    md: '$2',
    lg: '$6',
  },
  maxWidth: {
    base: '135px',
    md: 'full',
  },
});

export const Disclaimer = Text.withConfig({
  marginTop: {
    base: '$4',
    md: '$8',
  },
  fontSize: 'sm',
  textAlign: {
    base: 'center',
    md: 'left',
  },
});
